<template>
    <section id="skills" class="py-24 px-4 sm:px-6 lg:px-8 bg-slate-50">
      <div class="max-w-6xl mx-auto">
        <div class="text-center mb-16">
          <p class="text-emerald-600 text-sm font-semibold tracking-widest uppercase mb-3">Skills & Tools</p>
          <h2 class="text-3xl sm:text-4xl font-bold text-slate-900">
            Technologies I <span class="text-emerald-600">work with</span>
          </h2>
        </div>
        
        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          <div v-for="skill in skills" :key="skill.name" 
               class="group bg-white p-4 sm:p-6 rounded-xl border border-slate-100 hover:border-emerald-200 hover:shadow-lg hover:shadow-emerald-500/5 transition-all duration-300">
            <div class="flex items-center gap-3 sm:gap-4">
              <div class="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-slate-100 group-hover:bg-emerald-50 flex items-center justify-center p-2 transition-colors duration-300 flex-shrink-0">
                <img :src="skill.icon" :alt="skill.name" class="w-full h-full object-contain" />
              </div>
              <h3 class="font-semibold text-slate-900 text-sm sm:text-base min-w-0 break-words">{{ skill.name }}</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script setup>
import { skills } from '../data/portfolio.js'
</script>
